<template>
  <div class="t-tag" :class="[
    {'s_tag': STag},
    {'smallCard_tag': smallCard},
    {'glod_tag': goldTag}
  ]">
    {{ txt }}
  </div>
</template>

<script>
export default {
  name: 't-tag',
  props: {
    txt: {
      type: String,
      default: 'brand'
    },
    // 小一号的tag
    STag: {
      type: Boolean,
      default: true
    },
    // 红色标签
    redColor: {
      type: Boolean,
      default: true
    },
    // 金色标签
    goldTag: {
      type: Boolean,
      default: false
    },
    smallCard: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/theme.less';
  .t-tag {
    // width: 52px;
    font-family: PingFangSC-Light;
    font-size: 12px;
    color: #FFFFFF;
    letter-spacing: 0.3px;
    text-align: center;
    line-height: 12px;
    margin: 0 4px;
    border-radius: 2px;
    background: rgba(30, 30, 30, .7);
    // padding: 5px 6px;
    padding: 4px 8px;
    position: relative;
    &:after {
      .hairlintag(#fff);
    }
    border-radius: 2px;
  }

  .s_tag {
    border-radius: 2px;
    // width: 52px;
    // padding: 3px 3px;
    // padding: 3px 8px;
    background: #fff;;
    border-radius: 2px;
    font-family: PingFangSC-Light;
    font-size: 12px;
    color: #333333;
    letter-spacing: 0.15px;
    text-align: center;
    line-height: 12px;
    &:after {
      .hairlintag(#333);
    }
  }
  .smallCard_tag {
    font-family: PingFangSC-Light;
    font-size: 10px;
    color: #333333;
    letter-spacing: 0.15px;
    text-align: center;
    line-height: 10px;
  }
  .red_color {
    color: @primary-color;
    &:after {
      .hairlintag(@primary-color);
    }
  }
  .glod_tag {
    // background-color: #C9AA79;
    // color: #fff;
    color: #C04374;
    // color: #C9AA79;
    &:after {
      .hairlintag(#C04374);
      // .hairlintag(#C9AA79);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TTag.vue